import { render, staticRenderFns } from "./clientsCratesBalance.vue?vue&type=template&id=07d58db9&scoped=true&"
import script from "./clientsCratesBalance.vue?vue&type=script&lang=js&"
export * from "./clientsCratesBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d58db9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
